import React, { Component, PropTypes } from "react";
import {
  Input,
  Dropdown,
  Loader,
  Dimmer,
  Checkbox,
  Modal,
} from "semantic-ui-react";
import { connect } from "react-redux";
import {
  ValidMe,
  forceValidation,
  validatePhoneNumber,
  phoneTypesEnum,
  EMAIL_VALIDATION_REGULAR_EXPRESSION,
} from "../../shared/validMeReact";
import {
  getApiCustomerProfileData,
  updateBookingOnlyCustomerProfileData,
  setIsLoadingOnCustomerProfile,
  updateCustomerProfileData,
  resetCustomerProfileForm,
  updateShouldSaveAppointmentOnceWeGoBackFromCustomerProfile,
} from "../../../actions/customerProfile";
import objectAssign from "object-assign";
import AddressForm from "../../shared/addressForm";
import {
  updateGlobalErrorMessage,
  removeGlobalErrorMessageIfMatchesThisString,
} from "../../../actions/globalError";
import { menuNamesEnum } from "../../../state/initialState";
import {
  updateCurrentMenu,
  updateBookingCustomerProfileModalVisibility,
} from "../../../actions/menu";
import { updateAppointmentStepData } from "../../../actions/appointmentStep";
import { formatPhone } from "../../../utils/helpers";

@connect(mapStateToProps)
export default class BookingCustomerProfileModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredHelpAddress: false,
      hoveredHelpUpdateAllRecords: false,
      hoveredHelpViewCustomerDetails: false,
      hoveredSave: false,
    };
  }

  componentDidMount() {
    const { bookingOnlyCustomerProfileData } = this.props;
    sessionStorage.setItem(
      "BOOKING_ONLY_CUSTOMER_PROFILE_SNAPSHOT",
      JSON.stringify(bookingOnlyCustomerProfileData)
    );

    this.props.dispatch(updateGlobalErrorMessage(""));
  }

  updateBookingOnlyCustomerProfileData = (data) => {
    let newData = objectAssign(
      {},
      this.props.bookingOnlyCustomerProfileData,
      data
    );
    this.props.dispatch(updateBookingOnlyCustomerProfileData(newData));
  };

  firstNameChangeHandler = (event) => {
    this.updateBookingOnlyCustomerProfileData({
      firstName: event.target.value,
    });
    setTimeout(() => {
      forceValidation(null, null, "customerProfileNames");
    }, 0);
  };

  lastNameChangeHandler = (event) => {
    this.updateBookingOnlyCustomerProfileData({ lastName: event.target.value });
    setTimeout(() => {
      forceValidation(null, null, "customerProfileNames");
    }, 0);
  };

  emailChangeHandler = (event) => {
    const { apiCustomerProfileData } = this.props;
    const { ErrorEmailCannotBeDeletedInThisPage } = window.APP.LANGUAGE.Errors;

    this.updateBookingOnlyCustomerProfileData({ email: event.target.value });
  };

  phoneChangeHandler = (event) => {
    const noSpacesPhone = event.target.value
      .split(" ")
      .join()
      .replace(/,/g, "")
      .replace(/\(/g, "")
      .replace(/\)/g, "")
      .replace(/-/g, "")
      .replace(/\+/g, "");
    const numericTest = /^\d+$/;
    if (
      numericTest.test(noSpacesPhone) ||
      event.target.value == "" ||
      event.target.value == "+"
    ) {
      if (event.type == "change") {
        this.updateBookingOnlyCustomerProfileData({
          phoneNumber: event.target.value,
        }); // DES- 709 formatting in change causes issues. Hence moved to blur. But without state update it will not reflect in UI.
      } else {
        this.updateBookingOnlyCustomerProfileData({
          phoneNumber: formatPhone(event.target.value),
        });
      }
    }

    if (event.type !== "change") {
      setTimeout(() => {
        forceValidation(null, null, "customerProfileContacts");
      }, 0); //execute in next loop
    }
  };

  updateBookingOnlyCustomerAddressData = (data) => {
    const newAddressData = objectAssign(
      {},
      this.props.bookingOnlyCustomerProfileData.address,
      data
    );
    this.updateBookingOnlyCustomerProfileData({ address: newAddressData });
  };

  address1ChangeHandler = (addressValue) => {
    this.updateBookingOnlyCustomerAddressData({ address1: addressValue });
  };

  cityChangeHandler = (cityValue) => {
    this.updateBookingOnlyCustomerAddressData({ city: cityValue });
  };

  stateChangeHandler = (selectedState) => {
    this.updateBookingOnlyCustomerAddressData({ state: selectedState });
  };

  postalCodeChangeHandler = (zipCodeValue) => {
    this.updateBookingOnlyCustomerAddressData({ postalcode: zipCodeValue });
  };

  handleHelpAddressMouseIn = () => {
    this.setState({ hoveredHelpAddress: true });
  };

  handleHelpAddressMouseOut = () => {
    this.setState({ hoveredHelpAddress: false });
  };

  handleHelpUpdateAllRecordsMouseIn = () => {
    this.setState({ hoveredHelpUpdateAllRecords: true });
  };

  handleHelpUpdateAllRecordsMouseOut = () => {
    this.setState({ hoveredHelpUpdateAllRecords: false });
  };

  handleHelpViewCustomerDetailsMouseIn = () => {
    this.setState({ hoveredHelpViewCustomerDetails: true });
  };

  handleHelpViewCustomerDetailsMouseOut = () => {
    this.setState({ hoveredHelpViewCustomerDetails: false });
  };

  handleSaveMouseIn = () => {
    this.setState({ hoveredSave: true });
  };

  handleSaveMouseOut = () => {
    this.setState({ hoveredSave: false });
  };

  updateBookingCustomerProfileModalVisibility = (isVisible) => {
    this.props.dispatch(
      updateCurrentMenu(menuNamesEnum.FIRST_STEP_APPOINTMENT)
    );
    this.props.dispatch(updateBookingCustomerProfileModalVisibility(isVisible));
  };

  closeClickHandler = () => {
    this.updateBookingCustomerProfileModalVisibility(false);

    const selectedCustomer = this.props.appointmentStepData.selectedCustomer;

    const customerData = {
      email: selectedCustomer.email,
      phoneNumber: selectedCustomer.phone,
      firstName: selectedCustomer.firstname,
      lastName: selectedCustomer.lastname,
      address: selectedCustomer.address,
    };

    this.updateBookingOnlyCustomerProfileData(customerData);
  };

  saveClickHandler = () => {
    const {
      bookingOnlyCustomerProfileData,
      appointmentStepData: { selectedCustomer },
      appointmentStepData,
      limitedPermissions,
      currentBookingId,
    } = this.props;

    selectedCustomer.email = bookingOnlyCustomerProfileData.email;
    selectedCustomer.phone = bookingOnlyCustomerProfileData.phoneNumber;
    selectedCustomer.firstname = bookingOnlyCustomerProfileData.firstName;
    selectedCustomer.lastname = bookingOnlyCustomerProfileData.lastName;
    selectedCustomer.address = bookingOnlyCustomerProfileData.address;

    const newData = objectAssign({}, this.props.appointmentStepData, {
      selectedCustomer,
      address: bookingOnlyCustomerProfileData.address,
    });

    this.props.dispatch(updateAppointmentStepData(newData));

    setTimeout(() => {
      this.props.dispatch(
        updateCurrentMenu(menuNamesEnum.FIRST_STEP_APPOINTMENT)
      );
      this.props.dispatch(updateBookingCustomerProfileModalVisibility(false));
    }, 0); // this is required because the cb is not called after the customer has been updated in the app state, but rather, before that, so we wait until the next JS app cycle

    sessionStorage.setItem(
      "BOOKING_ONLY_CUSTOMER_PROFILE_SNAPSHOT",
      JSON.stringify(bookingOnlyCustomerProfileData)
    );
  };

  render() {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      address,
    } = this.props.bookingOnlyCustomerProfileData;
    const { currentBookingId, limitedPermissions } = this.props;
    const { CustomerProfile } = window.APP.LANGUAGE.Pages;
    const { PopupWindows } = window.APP.LANGUAGE.Shared;

    const phoneTypesSupported = `${phoneTypesEnum.MOBILE}-${phoneTypesEnum.FIXED_LINE}-${phoneTypesEnum.FIXED_LINE_OR_MOBILE}-${phoneTypesEnum.PERSONAL_NUMBER}-${phoneTypesEnum.VOIP}-${phoneTypesEnum.TOLL_FREE}`;
    const {
      UpdateAllCustomerRecords,
      DetailsTitle,
      RequiredFields,
      ContactTitle,
      OneFieldRequired,
      FirstNamePlaceholder,
      LastNamePlaceholder,
      EmailPlaceholder,
      PhonePlaceholder,
      AddressTitle,
      BlockCustomerText,
      AlwaysRequireCCText,
      ViewDetailsText,
      CannotEditCustomerProfileMessage,
      UpdateAllCustomersHelpMessage,
      ViewCustomerDetailsHelpMessage,
      UpdateBookingOnlyCustomerHelpMessage,
    } = CustomerProfile;

    let that = this;
    return (
      <Modal
        className="bookingdetails-model transparent-bg no-borders"
        open={true}
      >
        <Modal.Content className="tip_popup transparent-bg">
          <div className="tip_overlay"></div>
          <div className="store-credit-card-box customer-profile-box">
            <section className="header">
              {PopupWindows.CustomerProfileTitle}
              <div
                className="close_button"
                onClick={() => this.closeClickHandler()}
              ></div>
            </section>
            <div className="ui form">
              <section className="customer-info two fields">
                <ValidMe
                  condition={() => {
                    return (
                      this.props.bookingOnlyCustomerProfileData.firstName
                        .length > 0 ||
                      this.props.customerProfileData.lastname.length > 0
                    );
                  }}
                  validmemessagecondition={CustomerProfile.Errors.NameRequired}
                  validmefor="condition"
                  group="customerProfileNames"
                >
                  <Input
                    value={firstName}
                    onChange={this.firstNameChangeHandler}
                    autoComplete="off"
                    name="booking_firstName"
                    tabIndex="1"
                    placeholder={FirstNamePlaceholder}
                  />
                </ValidMe>
                <ValidMe
                  condition={() => {
                    return (
                      this.props.bookingOnlyCustomerProfileData.firstName
                        .length > 0 ||
                      this.props.bookingOnlyCustomerProfileData.lastname
                        .length > 0
                    );
                  }}
                  validmemessagecondition={CustomerProfile.Errors.NameRequired}
                  validmefor="condition&numeric"
                  group="customerProfileNames"
                >
                  <Input
                    value={lastName}
                    onChange={this.lastNameChangeHandler}
                    autoComplete="off"
                    name="booking_lastName"
                    tabIndex="2"
                    placeholder={LastNamePlaceholder}
                    className="booking_auto_complete"
                  />
                </ValidMe>
              </section>
              <section className="customer-info2 two fields">
                <ValidMe
                  hideerrorsofgroupifallgood={true}
                  condition={(value) => {
                    let emailValue = value;
                    let conditionFulfilled = true;
                    if (
                      value != "" &&
                      !EMAIL_VALIDATION_REGULAR_EXPRESSION.test(value)
                    ) {
                      conditionFulfilled = false;
                    }
                    return conditionFulfilled;
                  }}
                  validmemessagecondition={
                    CustomerProfile.Errors.ContactRequired
                  }
                  validmemessage={window.APP.LANGUAGE.Errors.EmailInvalid}
                  optional
                  validmefor="condition&email"
                  group="customerProfileContacts"
                >
                  <Input
                    type="email"
                    value={email}
                    onBlur={() => {
                      setTimeout(() => {
                        forceValidation(null, null, "customerProfileContacts");
                      }, 0); //execute in next loop
                    }}
                    onChange={this.emailChangeHandler}
                    autoComplete="off"
                    name="booking_email"
                    tabIndex="3"
                    placeholder={EmailPlaceholder}
                    className="booking_email_cp booking_auto_complete customer-email"
                  />
                </ValidMe>

                <ValidMe
                  hideerrorsofgroupifallgood={true}
                  condition={(value, validRules, props) => {
                    let phone = value;
                    let conditionFulfilled = true;
                    phone = phone.replace("+", "");
                    if (
                      value != "" &&
                      !validatePhoneNumber(phone, validRules, props).good
                    ) {
                      conditionFulfilled = false;
                    }

                    return conditionFulfilled;
                  }}
                  validmemessagecondition={
                    CustomerProfile.Errors.ContactRequired
                  }
                  validmemessage={
                    window.APP.LANGUAGE.Errors.PhoneNumberIsInvalid
                  }
                  optional
                  validmefor={`condition&phoneNumber@${phoneTypesSupported}`}
                  group="customerProfileContacts"
                >
                  <Input
                    onBlur={this.phoneChangeHandler}
                    type="tel"
                    value={phoneNumber}
                    onChange={this.phoneChangeHandler}
                    autoComplete="off"
                    name="booking_phonenumber"
                    tabIndex="4"
                    placeholder={PhonePlaceholder}
                    className="booking_auto_complete customer-phone"
                  />
                </ValidMe>
              </section>
            </div>

            <section className={`address ui form`}>
              {!limitedPermissions.canEditCustomerProfile ? (
                <span
                  onMouseOver={this.handleHelpAddressMouseIn}
                  onMouseOut={this.handleHelpAddressMouseOut}
                  className="message-on-top-tooltip"
                >
                  {this.state.hoveredHelpAddress ? (
                    <div className="contact-details-no-access-help">
                      {CannotEditCustomerProfileMessage}
                    </div>
                  ) : (
                    ""
                  )}
                </span>
              ) : (
                ""
              )}
              <AddressForm
                postalCodeChangeHandler={this.postalCodeChangeHandler}
                addressValue={address}
                addressChangeHandler={this.address1ChangeHandler}
                cityChangeHandler={this.cityChangeHandler}
                stateChangeHandler={this.stateChangeHandler}
                postalCodeChangeHandler={this.postalCodeChangeHandler}
                isCustomerPopup="true"
              />
            </section>
            <div className="ui clearing aligned booking_footer modal-footer">
              <br />

              <div
                onClick={this.saveClickHandler}
                data-group="customerProfileNames&customerProfile&customerProfileContacts"
                className="ui button btn-default save-customer no-border-button"
              >
                {PopupWindows.UpdateAppointment}
              </div>
            </div>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    customerProfileData: state.customerProfileReducer.customerProfileData,
    bookingOnlyCustomerProfileData:
      state.customerProfileReducer.bookingOnlyCustomerProfileData,
    apiCustomerProfileData: state.customerProfileReducer.apiCustomerProfileData,
    businessCountryCode: state.appointmentStepReducer.businessCountryCode,
    currentBookingId: state.bookingReducer.currentBookingId,
    loadingCustomerProfile: state.customerProfileReducer.loadingCustomerProfile,
  };
}
